/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "m1 14.86 2.76-2.76m10.9 2.76-2.7-2.48m-8.2-.28 1.93 1.38 1.93-1.1 2.35 1.1 2-1.1m-8.21-.28L5.69 10l4.1.14 2.18 2.24",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M7.5 9c0-.5.16-1.43-2.99-2-.56-.3-1.01-.5-1.35-.93-.07-.1-.8-1.31 1.7-1.81m-1.14.36c-.5-.67-.56-2.05-.06-2.55 1.08-1.08 2.5-1.5 4-.5s1 2.5 0 2.5M8.5 2.5s2.5-.5 4 .5 2 4 .5 4.5-3.69-.45-4 0c-.25.36-1.3 1.6-1.5 2",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
